import React, { useState, useEffect, useRef } from "react";
import axios from "../utils/axiosInstance";
import SignatureCanvas from "react-signature-canvas";
import "../page/page-styles.css";

const BASE = "/mudugudu/umutekano";

const UmutekanoMudugudu = () => {
  const [leader, setLeader] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const [form, setForm] = useState({ national_id: "", fullname: "", email: "", telephone: "", password: "", confirmPassword: "" });
  const [regLoading, setRegLoading] = useState(false);
  const [editingLeader, setEditingLeader] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  const [activeSection, setActiveSection] = useState("leader");
  const [ibirego, setIbirego] = useState([]);
  const [ibibazo, setIbibazo] = useState([]);
  const [amakuru, setAmakuru] = useState([]);
  const [selectedIcyirego, setSelectedIcyirego] = useState(null);

  const [showSigModal, setShowSigModal] = useState(false);
  const [sigTargetId, setSigTargetId] = useState(null);
  const sigRef = useRef(null);

  const token = localStorage.getItem("token");
  const auth = { headers: { Authorization: `Bearer ${token}` } };

  const fetchLeader = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${BASE}-leader`, auth);
      setLeader(res.data?.id ? res.data : null);
    } catch { setLeader(null); }
    finally { setLoading(false); }
  };

  useEffect(() => { fetchLeader(); }, []);

  const handleRegChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleEditLeader = () => {
    if (!leader) return;
    setEditingLeader(true);
    setForm({
      national_id: leader.national_id || "",
      fullname: leader.fullname || "",
      email: leader.email || "",
      telephone: leader.telephone || "",
      password: "",
      confirmPassword: "",
    });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleDeleteLeader = async () => {
    if (!leader) return;
    setRegLoading(true);
    try {
      await axios.delete(`${BASE}-leader/${leader.id}`, auth);
      setSuccess("✅ Umuyobozi w'umutekano yasibwe neza!");
      setLeader(null);
      setShowDeleteConfirm(false);
      setEditingLeader(false);
      setForm({ national_id: "", fullname: "", email: "", telephone: "", password: "", confirmPassword: "" });
    } catch (err) {
      setError(err.response?.data?.error || "Gusiba ntibyakunze");
    } finally { setRegLoading(false); }
  };

  const cancelEdit = () => {
    setEditingLeader(false);
    setForm({ national_id: "", fullname: "", email: "", telephone: "", password: "", confirmPassword: "" });
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setError(""); setSuccess("");
    if (!form.fullname.trim()) return setError("Amazina Yose arirakenewe");
    if (!editingLeader) {
      if (!form.national_id.trim()) return setError("Indangamuntu irakenewe");
      if (!form.password) return setError("Password irakenewe");
      if (form.password !== form.confirmPassword) return setError("Password ntizihuye");
      if (form.password.length < 6) return setError("Password igomba kugira nibura 6");
    } else {
      if (form.password && form.password !== form.confirmPassword) return setError("Password ntizihuye");
      if (form.password && form.password.length < 6) return setError("Password igomba kugira nibura 6");
    }
    setRegLoading(true);
    try {
      if (editingLeader) {
        await axios.put(`${BASE}-leader/${leader.id}`, {
          national_id: form.national_id.replace(/\s/g, ""),
          fullname: form.fullname,
          email: form.email || undefined,
          telephone: form.telephone || undefined,
          password: form.password || undefined,
        }, auth);
        setSuccess("✅ Umuyobozi w'umutekano yavuguruwe neza!");
      } else {
        await axios.post("/register_umutekano", {
          national_id: form.national_id.replace(/\s/g, ""),
          fullname: form.fullname,
          email: form.email || undefined,
          telephone: form.telephone || undefined,
          password: form.password,
        }, auth);
        setSuccess("✅ Umuyobozi Ushinzwe Umutekano yanditswe neza!");
      }
      setForm({ national_id: "", fullname: "", email: "", telephone: "", password: "", confirmPassword: "" });
      setEditingLeader(false);
      fetchLeader();
    } catch (err) {
      setError(err.response?.data?.error || (editingLeader ? "Guhindura ntibyakunze" : "Kwiyandikisha ntibyakunze"));
    } finally { setRegLoading(false); }
  };

  const fetchIbirego = async () => {
    try { const res = await axios.get(`${BASE}/ibirego`, auth); setIbirego(Array.isArray(res.data) ? res.data : []); } catch {}
  };
  const fetchIbibazo = async () => {
    try { const res = await axios.get(`${BASE}/ibibazo`, auth); setIbibazo(Array.isArray(res.data) ? res.data : []); } catch {}
  };
  const fetchAmakuru = async () => {
    try { const res = await axios.get(`${BASE}/amakuru`, auth); setAmakuru(Array.isArray(res.data) ? res.data : []); } catch {}
  };

  const viewIcyirego = async (id) => {
    try { const res = await axios.get(`${BASE}/icyirego/${id}`, auth); setSelectedIcyirego(res.data); } catch {}
  };

  useEffect(() => { if (activeSection === "ibirego") fetchIbirego(); }, [activeSection]);
  useEffect(() => { if (activeSection === "ibibazo") fetchIbibazo(); }, [activeSection]);
  useEffect(() => { if (activeSection === "amakuru") fetchAmakuru(); }, [activeSection]);

  const handleSignSubmit = async () => {
    if (!sigRef.current || sigRef.current.isEmpty()) return setError("Shyiramo umukono wawe");
    const signature_image = sigRef.current.toDataURL();
    try {
      await axios.post(`${BASE}/icyirego/${sigTargetId}/sign`, { signature_image }, auth);
      setShowSigModal(false); setSigTargetId(null);
      fetchIbirego(); setSuccess("✅ Umudugudu wasinye!");
    } catch (err) { setError(err.response?.data?.error || "Error"); }
  };

  const handleSendToAkagari = async (id) => {
    try {
      await axios.post(`${BASE}/icyirego/${id}/send-to-akagari`, {}, auth);
      fetchIbirego(); setSuccess("✅ Icyirego cyoherejwe mu Kagari!");
    } catch (err) { alert(err.response?.data?.error || "Error"); }
  };

  const tabs = [
    { key: "leader",  icon: "bi-person-badge",       label: "Umuyobozi" },
    { key: "ibirego", icon: "bi-file-earmark-text",   label: "Ibirego" },
    { key: "ibibazo", icon: "bi-exclamation-triangle", label: "Ibibazo" },
    { key: "amakuru", icon: "bi-info-circle",          label: "Amakuru" },
  ];

  if (loading) return (
    <div className="page-root" style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: 200 }}>
      <div className="spinner-border" role="status" />
    </div>
  );

  return (
    <div className="page-root">

      {/* SIGNATURE MODAL */}
      {showSigModal && (
        <div className="modal-backdrop" onClick={() => setShowSigModal(false)}>
          <div className="modal-box" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <span className="modal-title"><i className="bi bi-pen me-2" />Shyiramo umukono w'Umudugudu</span>
              <button className="btn-ghost btn btn-sm btn-icon" onClick={() => setShowSigModal(false)}>✕</button>
            </div>
            <div className="modal-body">
              <div style={{ background: "rgba(255,255,255,0.03)", border: "1px solid rgba(99,102,241,0.2)", borderRadius: 12, padding: 4, touchAction: "none" }}>
                <SignatureCanvas ref={sigRef} penColor="#6366f1"
                  canvasProps={{ width: 450, height: 180, style: { width: "100%", height: 180, borderRadius: 10 } }} />
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn-outline-tw btn-sm" onClick={() => sigRef.current?.clear()}>Kuraho</button>
              <button className="btn-outline-tw btn-sm" onClick={() => setShowSigModal(false)}>Reka</button>
              <button className="btn-primary-tw btn-sm" onClick={handleSignSubmit}>Ohereza</button>
            </div>
          </div>
        </div>
      )}

      {/* PAGE HEADER */}
      <div className="page-header">
        <div>
          <h1 className="page-title"><i className="bi bi-shield-lock-fill me-2" />Umuyobozi Ushinzwe Umutekano</h1>
          <p className="page-subtitle">Gucunga umutekano w'umudugudu</p>
        </div>
      </div>

      {error && (
        <div className="alert alert-error mb-4">
          <i className="bi bi-exclamation-circle-fill" />{error}
        </div>
      )}
      {success && (
        <div className="alert alert-success mb-4">
          <i className="bi bi-check-circle-fill" />{success}
        </div>
      )}

      {/* TABS */}
      <div style={{ display: "flex", gap: "0.5rem", flexWrap: "wrap", marginBottom: "1.25rem" }}>
        {tabs.map(({ key, icon, label }) => (
          <button key={key} onClick={() => setActiveSection(key)}
            className={activeSection === key ? "btn-primary-tw" : "btn-outline-tw"}
            style={{ minHeight: 38, padding: "0.4rem 1rem", fontSize: "0.85rem" }}>
            <i className={`bi ${icon} me-1`} />{label}
          </button>
        ))}
      </div>

      {/* LEADER SECTION */}
      {activeSection === "leader" && (
        <div style={{ display: "flex", flexDirection: "column", gap: "1.25rem" }}>

          {/* Current leader info card */}
          <div className="card">
            <div className="card-header">
              <span className="card-title"><i className="bi bi-person-badge me-2" />Umuyobozi w'Umutekano</span>
            </div>
            <div className="card-body">
              {leader ? (
                <div>
                  <div style={{ display: "flex", alignItems: "center", gap: "1rem", marginBottom: "0.75rem" }}>
                    <div className="stat-icon" style={{ background: "rgba(99,102,241,0.15)", color: "#a5b4fc", width: 48, height: 48, borderRadius: 12, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                      <i className="bi bi-person-fill" style={{ fontSize: "1.3rem" }} />
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: 700, fontSize: "1rem", color: "#f1f5f9" }}>{leader.fullname}</div>
                      <div style={{ color: "#94a3b8", fontSize: "0.82rem", marginTop: 3 }}>
                        {leader.national_id}{leader.email && ` · ${leader.email}`}{leader.telephone && ` · ${leader.telephone}`}
                      </div>
                    </div>
                    <span className="badge-tw success" style={{ flexShrink: 0 }}>
                      <i className="bi bi-shield-check me-1" />Yanditswe
                    </span>
                  </div>
                  <div style={{ display: "flex", gap: "0.5rem" }}>
                    <button className="btn-outline-tw" style={{ fontSize: "0.82rem", padding: "0.35rem 0.8rem" }} onClick={handleEditLeader}>
                      <i className="bi bi-pencil me-1" />Hindura
                    </button>
                    <button className="btn-outline-tw" style={{ fontSize: "0.82rem", padding: "0.35rem 0.8rem", borderColor: "rgba(239,68,68,0.3)", color: "#f87171" }} onClick={() => setShowDeleteConfirm(true)}>
                      <i className="bi bi-trash me-1" />Siba
                    </button>
                  </div>
                </div>
              ) : (
                <div style={{ display: "flex", alignItems: "center", gap: "0.75rem", color: "#a1a1aa", fontSize: "0.9rem" }}>
                  <i className="bi bi-person-x" style={{ fontSize: "1.3rem", color: "#f87171" }} />
                  Nta muyobozi w'umutekano wanditswe kuri uyu mudugudu.
                </div>
              )}
            </div>
          </div>

          {/* Registration / Edit form */}
          <div className="card">
            <div className="card-header" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <span className="card-title">
                <i className={`bi ${editingLeader ? "bi-pencil-square" : "bi-person-plus-fill"} me-2`} />
                {editingLeader ? "Hindura Umuyobozi Ushinzwe Umutekano" : "Kwandika Umuyobozi Ushinzwe Umutekano"}
              </span>
                  {editingLeader && <span className="badge-tw warning"><i className="bi bi-pencil me-1" />Uguhindura</span>}
                  {!editingLeader && leader && <span className="badge-tw warning"><i className="bi bi-lock me-1" />Umuyobozi asanzwe ahari</span>}
            </div>
            <div className="card-body">
              {!editingLeader && leader && (
                <div className="alert alert-warning mb-4" style={{ background: "rgba(245,158,11,0.08)", border: "1px solid rgba(245,158,11,0.2)", borderRadius: 10, padding: "0.75rem 1rem", color: "#fbbf24", fontSize: "0.875rem", display: "flex", alignItems: "center", gap: "0.5rem", marginBottom: "1.25rem" }}>
                  <i className="bi bi-info-circle-fill" />
                  Kanda <strong>"Hindura"</strong> hejuru niba ushaka guhindura amakuru y'uyu muyobozi.
                </div>
              )}
              <form onSubmit={handleRegister}>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: "1rem", marginBottom: "1.25rem" }}>
                  {[
                    { name: "national_id",    label: editingLeader ? "Numero y'Irangamuntu" : "Numero y'Irangamuntu *", type: "text",     placeholder: "1190 8000 0000 0000" },
                    { name: "fullname",        label: editingLeader ? "Amazina Yose" : "Amazina Yose *",               type: "text",     placeholder: "Izina ndetse n'iryanyuma" },
                    { name: "email",           label: "Email",                    type: "email",    placeholder: "email@example.com" },
                    { name: "telephone",       label: "Nimero ya Telephone",      type: "text",     placeholder: "078 000 0000" },
                    { name: "password",        label: editingLeader ? "Ijambo ry'ibanga (niba uhindura)" : "Ijambo ry'ibanga *", type: "password", placeholder: editingLeader ? "Reka ubusa niba utahindura" : "6+ inyuguti" },
                    { name: "confirmPassword", label: editingLeader ? "Emeza ijambo ry'ibanga (niba uhindura)" : "Emeza ijambo ry'ibanga *", type: "password", placeholder: editingLeader ? "Reka ubusa niba utahindura" : "Ongera wandike ijambo ry'ibanga" },
                  ].map(({ name, label, type, placeholder }) => (
                    <div key={name}>
                      <label className="form-label">{label}</label>
                      <input
                        className="form-control"
                        name={name} type={type}
                        value={form[name]} onChange={handleRegChange}
                        placeholder={placeholder}
                        disabled={(!editingLeader && !!leader) || regLoading}
                      />
                    </div>
                  ))}
                </div>
                <div style={{ display: "flex", gap: "0.5rem" }}>
                  {editingLeader && (
                    <button type="button" className="btn-outline-tw" onClick={cancelEdit} disabled={regLoading}>
                      <i className="bi bi-x-circle me-1" />Reka
                    </button>
                  )}
                  <button type="submit" className="btn-primary-tw" disabled={(!editingLeader && !!leader) || regLoading}>
                    <i className={`bi ${editingLeader ? "bi-check-lg" : "bi-person-check-fill"} me-2`} />
                    {regLoading ? "Birimo..." : editingLeader ? "Emeza Guhindura" : "Emeza Kwandika Umuyobozi"}
                  </button>
                </div>
              </form>
            </div>
          </div>

        </div>
      )}

      {/* DELETE CONFIRMATION MODAL */}
      {showDeleteConfirm && leader && (
        <div className="modal-backdrop" onClick={() => setShowDeleteConfirm(false)}>
          <div className="modal-box" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 420 }}>
            <div className="modal-header">
              <span className="modal-title"><i className="bi bi-exclamation-triangle-fill me-2" style={{ color: "#f87171" }} />Siba Umuyobozi</span>
              <button className="btn-ghost btn btn-sm btn-icon" onClick={() => setShowDeleteConfirm(false)}>✕</button>
            </div>
            <div className="modal-body">
              <p style={{ color: "#cbd5e1", lineHeight: 1.6, margin: 0 }}>
                Ugiye gusiba <strong>{leader.fullname}</strong> (<em>{leader.national_id}</em>) 
                mu muyobozi w'umutekano w'uyu mudugudu.
              </p>
            </div>
            <div className="modal-footer">
              <button className="btn-outline-tw btn-sm" onClick={() => setShowDeleteConfirm(false)} disabled={regLoading}>
                Reka
              </button>
              <button className="btn-outline-tw btn-sm" style={{ borderColor: "rgba(239,68,68,0.3)", color: "#f87171" }} onClick={handleDeleteLeader} disabled={regLoading}>
                {regLoading ? "Birimo..." : "Yego, Siba"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* IBIREGO SECTION */}
      {activeSection === "ibirego" && (
        <div className="card">
          <div className="card-header">
            <span className="card-title"><i className="bi bi-file-earmark-text me-2" />Ibirego byoherejwe n'Umuyobozi w'Umutekano</span>
          </div>
          <div className="card-body">
            {selectedIcyirego ? (
              <div>
                <button className="btn-outline-tw mb-4" style={{ fontSize: "0.85rem" }} onClick={() => setSelectedIcyirego(null)}>
                  <i className="bi bi-arrow-left me-1" />Subira
                </button>
                <div style={{ background: "rgba(99,102,241,0.05)", border: "1px solid rgba(99,102,241,0.15)", borderRadius: 12, padding: "1.25rem", marginBottom: "1rem" }}>
                  <h5 style={{ color: "#f1f5f9", fontWeight: 700, marginBottom: "0.4rem" }}>{selectedIcyirego.icyitiriro || `Icyirego #${selectedIcyirego.id}`}</h5>
                  <div style={{ color: "#94a3b8", fontSize: "0.85rem", marginBottom: "0.5rem" }}>{selectedIcyirego.ubwoko_icyaha} — {selectedIcyirego.ahantu}</div>
                  <p style={{ color: "#cbd5e1", lineHeight: 1.6, marginBottom: "0.5rem" }}>{selectedIcyirego.ibisobanuro}</p>
                  <div style={{ color: "#94a3b8", fontSize: "0.8rem" }}>
                    <i className="bi bi-person-fill me-1" />{selectedIcyirego.uwitwa} | {selectedIcyirego.telefone}
                  </div>
                  {selectedIcyirego.umudugudu_signature && (
                    <div style={{ marginTop: "0.75rem" }}>
                      <div className="badge-tw success mb-2"><i className="bi bi-check-circle-fill me-1" />Umukono w'Umudugudu</div>
                      <img src={selectedIcyirego.umudugudu_signature} alt="Umukono" style={{ maxWidth: 200, maxHeight: 60, border: "1px solid rgba(99,102,241,0.2)", borderRadius: 8 }} />
                    </div>
                  )}
                </div>
                <div style={{ display: "flex", gap: "0.5rem", flexWrap: "wrap" }}>
                  {!selectedIcyirego.umudugudu_signature && (
                    <button className="btn-primary-tw" style={{ fontSize: "0.85rem" }} onClick={() => { setSigTargetId(selectedIcyirego.id); setShowSigModal(true); }}>
                      <i className="bi bi-pen me-1" />Shyirayo umukono w'Umudugudu
                    </button>
                  )}
                  {selectedIcyirego.umudugudu_signature && !selectedIcyirego.sent_to_kagari_at && (
                    <button className="btn-primary-tw" style={{ fontSize: "0.85rem", background: "linear-gradient(135deg,#10b981,#059669)" }} onClick={() => handleSendToAkagari(selectedIcyirego.id)}>
                      <i className="bi bi-send me-1" />Ohereza muri Akagari
                    </button>
                  )}
                  {selectedIcyirego.sent_to_kagari_at && (
                    <span className="badge-tw success"><i className="bi bi-send-check me-1" />Yoherejwe muri Akagari</span>
                  )}
                </div>
              </div>
            ) : (
              <div className="table-wrapper-tw">
                <div className="table-scroll-tw">
                  <table className="data-table">
                    <thead><tr>
                      <th>Icyitiriro</th><th>Ubwoko</th><th>Uwitwa</th><th>Itariki</th><th>Umukono</th><th>Ibikorwa</th>
                    </tr></thead>
                    <tbody>
                      {ibirego.length === 0 ? (
                        <tr><td colSpan={6} style={{ textAlign: "center", color: "#71717a" }}>Nta birego</td></tr>
                      ) : ibirego.map((r) => (
                        <tr key={r.id} style={{ cursor: "pointer" }} onClick={() => viewIcyirego(r.id)}>
                          <td>{r.icyitiriro || `#${r.id}`}</td>
                          <td>{r.ubwoko_icyaha}</td>
                          <td>{r.uwitwa}</td>
                          <td>{r.itariki_ikozwaho ? new Date(r.itariki_ikozwaho).toLocaleDateString() : "—"}</td>
                          <td>{r.umudugudu_signature ? <span className="badge-tw success">Yasinywe</span> : <span className="badge-tw warning">Ntumukono</span>}</td>
                          <td>{r.sent_to_kagari_at ? <span className="badge-tw info">Yoherejwe</span> : <span className="badge-tw neutral">Iritegereje</span>}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* IBIBAZO SECTION */}
      {activeSection === "ibibazo" && (
        <div className="card">
          <div className="card-header">
            <span className="card-title"><i className="bi bi-exclamation-triangle me-2" />Ibibazo by'Umutekano byoherejwe</span>
          </div>
          <div className="card-body">
            <div className="table-wrapper-tw">
              <div className="table-scroll-tw">
                <table className="data-table">
                  <thead><tr>
                    <th>Ubwoko</th><th>Uwaravuze</th><th>Ahabereye</th><th>Itariki</th><th>Igihe</th><th>Ibisobanuro</th>
                  </tr></thead>
                  <tbody>
                    {ibibazo.length === 0 ? (
                      <tr><td colSpan={6} style={{ textAlign: "center", color: "#71717a" }}>Nta bibazo</td></tr>
                    ) : ibibazo.map((r) => (
                      <tr key={r.id}>
                        <td><span className={`badge-tw ${r.ubwoko === "Ubujura" ? "danger" : r.ubwoko === "Intonganya" ? "warning" : "info"}`}>{r.ubwoko}</span></td>
                        <td>{r.amazina_uwaravuze}</td>
                        <td>{r.ahabereye}</td>
                        <td>{r.itariki ? new Date(r.itariki).toLocaleDateString() : "—"}</td>
                        <td>{r.igihe || "—"}</td>
                        <td style={{ maxWidth: 200, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{r.ibisobanuro}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* AMAKURU SECTION */}
      {activeSection === "amakuru" && (
        <div className="card">
          <div className="card-header">
            <span className="card-title"><i className="bi bi-info-circle me-2" />Amakuru y'Umutekano yoherejwe</span>
          </div>
          <div className="card-body">
            <div className="table-wrapper-tw">
              <div className="table-scroll-tw">
                <table className="data-table">
                  <thead><tr>
                    <th>Umutwe</th><th>Ibisobanuro</th><th>Itariki</th><th>Byoherejwe</th>
                  </tr></thead>
                  <tbody>
                    {amakuru.length === 0 ? (
                      <tr><td colSpan={4} style={{ textAlign: "center", color: "#71717a" }}>Nta makuru</td></tr>
                    ) : amakuru.map((r) => (
                      <tr key={r.id}>
                        <td>{r.umutwe}</td>
                        <td>{r.ibisobanuro}</td>
                        <td>{r.itariki ? new Date(r.itariki).toLocaleDateString() : "—"}</td>
                        <td>{r.byoherejwe ? <span className="badge-tw success">Yego</span> : <span className="badge-tw warning">Oya</span>}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UmutekanoMudugudu;
